import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import classNames from 'classnames';
import { FocusScope } from '@react-aria/focus';
import { DismissButton, useOverlay } from '@react-aria/overlays';
import { DropdownType } from '../../enums';
import commonStyles from '../scss/Dropdown.module.scss';
import styles from './Dropdown.module.scss';
const Overlay = ({ isOpen, onClose, children, dropdownType, overlayClasses, }) => {
    const ref = useRef(null);
    const { overlayProps } = useOverlay({
        isOpen,
        onClose,
        shouldCloseOnBlur: true,
        isDismissable: true,
    }, ref);
    // Wrap in <FocusScope> so that focus is restored back to the
    // trigger when the popup is closed.
    // Adding <DismissButton> components at the start and end of the list
    // to allow screen reader users to dismiss the popup easily.
    return (_jsx(FocusScope, { restoreFocus: true, children: _jsxs("div", { ...overlayProps, ref: ref, role: "dialog", className: classNames(commonStyles.dropdownBaseContainer, styles.dropdownContainer, overlayClasses, {
                [styles.isSecondary]: dropdownType === DropdownType.Secondary,
            }), children: [_jsx(DismissButton, { onDismiss: onClose }), children, _jsx(DismissButton, { onDismiss: onClose })] }) }));
};
export { Overlay };
